import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = axios.create({ baseURL: `${BACKEND_URL}/api` });

const getAuthHeaders = () => {
  const token = localStorage.getItem('adminToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getCards = (params) => API.get('/cards', { params });
export const getCard = (id) => API.get(`/cards/${id}`);
export const createCard = (data) => API.post('/cards', data, { headers: getAuthHeaders() });
export const updateCard = (id, data) => API.put(`/cards/${id}`, data, { headers: getAuthHeaders() });
export const deleteCard = (id) => API.delete(`/cards/${id}`, { headers: getAuthHeaders() });
export const compareCards = (cardIds) => API.post('/compare', { card_ids: cardIds });
export const getAIRecommendation = (data) => API.post('/ai/recommend', data);
export const getBanks = () => API.get('/banks');
export const getCardTypes = () => API.get('/card-types');
export const seedDatabase = () => API.post('/seed', {}, { headers: getAuthHeaders() });
export const adminLogin = (email, password) => API.post('/auth/login', { email, password });
export const getMe = () => API.get('/auth/me', { headers: getAuthHeaders() });

export default API;
